import { selector } from 'lib/selectors';
import { AgGridStateRecord } from 'domain/agGrid/types';

type RootState = {
  agGrid: AgGridStateRecord;
};

const agGrid = (state: RootState): AgGridStateRecord => state.agGrid;

export const agGridRefreshServerSideSelector = selector(agGrid, (g: AgGridStateRecord) => g.refreshServerSide);
export const agGridRefreshColumnDefsSelector = selector(agGrid, (g: AgGridStateRecord) => g.refreshColumnDefs);
